import { ThemeTag } from "entities/themeTags/types";
import { QueryDocumentSnapshot, Timestamp } from "firebase/firestore";
import { DocumentData, DocumentSnapshot } from "shared/api/firebase";
import { Translations } from "../../../shared/types/languages";

type ThemeTagDBT = {
  id: string;
  name: string;
  description: string;
  matchingGamesCount: number;
  tagType: string;
  translations?: Translations;
  updatedAt: Timestamp;
};

type ThemeTagDataT = Omit<ThemeTagDBT, "id">;

export class ThemeTagDB {
  id: string;
  name: string;
  description: string;
  matchingGamesCount: number;
  tagType: string;
  translations?: Translations;

  updatedAt: Timestamp;

  constructor(tag: QueryDocumentSnapshot | DocumentSnapshot<DocumentData>) {
    if (!tag.exists()) {
      throw new Error(`Tag ${tag.id} does not exist`);
    }

    const data = tag.data() as ThemeTagDataT;

    this.id = tag.id;
    this.name = data.name;
    this.description = data.description;
    this.matchingGamesCount = data.matchingGamesCount;
    this.tagType = data.tagType;
    this.updatedAt = data.updatedAt;
    this.translations = data.translations;
  }

  toThemeTag(): ThemeTag {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      matchingGamesCount: this.matchingGamesCount,
      tagType: this.tagType,
      updatedAt: this.updatedAt ? this.updatedAt?.toDate() : new Date(),
      translations: this.translations,
    };
  }
}
